import { atom } from "recoil";

export const onboardingState = atom({
  key: "onboardingState",
  default: {},
});

export const onboardingUserTagState = atom({
  key: "onboardingUserTagState",
  default: {},
});
